import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash-es';
import { parse } from 'query-string';

import { CampaignStatus, CampaignTypeFilter } from '@dev/ee-api/ee-api-models';

import { DEFAULT_OFFSET, DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { GetCampaignsPayload } from '@/store/campaigns/types';

export const useRequestParams = (): GetCampaignsPayload => {
    const location = useLocation();

    const query = parse(location.search, { parseBooleans: true });

    const status: CampaignStatus[] = isNil(query.status)
        ? null
        : typeof query.status === 'string'
        ? ([query.status] as CampaignStatus[])
        : (query.status as CampaignStatus[]);

    const limit = query?.perPage ? +query.perPage : DEFAULT_PER_PAGE_COUNT;
    const offset = query?.page ? +query.page * limit - limit : DEFAULT_OFFSET;
    const from = isNil(query?.from) ? null : (query?.from as string);
    const to = isNil(query?.to) ? null : (query?.to as string);
    const search = isNil(query?.search) ? null : (query?.search as string);
    const screenCampaignType = [CampaignTypeFilter.Automated];

    return {
        from,
        to,
        search,
        offset,
        limit,
        status,
        type: screenCampaignType,
    };
};
